/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyMonitoredObject,
    ReadOnlyMonitoredObjectFromJSON,
    ReadOnlyMonitoredObjectFromJSONTyped,
    ReadOnlyMonitoredObjectToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20029
 */
export interface InlineResponse20029 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20029
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20029
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20029
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyMonitoredObject>}
     * @memberof InlineResponse20029
     */
    results: Array<ReadOnlyMonitoredObject>;
}

export function InlineResponse20029FromJSON(json: any): InlineResponse20029 {
    return InlineResponse20029FromJSONTyped(json, false);
}

export function InlineResponse20029FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20029 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyMonitoredObjectFromJSON)),
    };
}

export function InlineResponse20029ToJSON(value?: InlineResponse20029 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyMonitoredObjectToJSON)),
    };
}


